export default "__VITE_ASSET__4a264849__"